import {API_URL} from 'api/constants'

export const DISCOUNTS = `${API_URL}/v2/discounts`
export const POST_DISCOUNT = `${API_URL}/v1/discounts`
export const PUT_DISCOUNT = (id) => `${API_URL}/v1/discounts/${id}`
export const DELETE_DISCOUNT = (id) => `${API_URL}/v1/discounts/${id}`
export const CREATE_ALL_OUTLET = `${API_URL}/v1/discounts/create_all_outlet`



// WEBPACK FOOTER //
// ./app/api/libraries/discounts/constants.js